import axios from 'axios';
import { loadingStore } from '@/stores/loadingStore';

class OpenAIService {
  constructor() {
    // Vue automatically exposes environment variables prefixed with VUE_APP_
    this.apiKey = process.env.VUE_APP_OPENAI_API_KEY;
    this.baseURL = 'https://api.openai.com/v1';
  }

  generateTaskId(method, endpoint) {
    return `${method}_${endpoint}_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }

  startApiLoading(message) {
    const taskId = this.generateTaskId('OpenAI', 'transcribe');
    loadingStore.startLoading(taskId, message);
    return taskId;
  }

  stopApiLoading(taskId) {
    if (taskId) {
      loadingStore.stopLoading(taskId);
    }
  }

  async transcribeAudio(audioBlob) {
    const taskId = this.startApiLoading('Transcribing audio...');
    
    try {
      if (!this.apiKey) {
        throw new Error('OpenAI API key is not set. Please add it to your .env file.');
      }

      const formData = new FormData();
      formData.append('file', audioBlob, 'audio.webm');
      formData.append('model', 'whisper-1');
      formData.append('response_format', 'json');

      const response = await axios.post(
        `${this.baseURL}/audio/transcriptions`, 
        formData, 
        {
          headers: {
            'Authorization': `Bearer ${this.apiKey}`,
            'Content-Type': 'multipart/form-data'
          }
        }
      );

      return response.data.text;
    } catch (error) {
      console.error('Error transcribing audio:', error);
      throw error;
    } finally {
      this.stopApiLoading(taskId);
    }
  }
}

export default new OpenAIService(); 